export default "__VITE_PUBLIC_ASSET__152962b7__"